import apiURLBuilder from '../core/apiURLBuilder';
import Api from '../services/api';
import { actions as formActions } from 'react-redux-form';
import { getAliasesDocumentType } from 'utilities/multiLanguageHelper';
import {
    ERROR_AL_AGREGAR_INTERVINIENTE,
    ERROR_AL_EDITAR_INTERVINIENTE,
    ERROR_AL_ELIMINAR_INTERVINIENTE,
} from 'constants/analyticsErrors';
import { PATH_ADD_JOINHOLDER } from 'constants/uTagConstants/paths';
import { errorTag } from 'utilities/uTagging';
import preLoaderActions from 'actions/preLoaderActions';
import { buildTgssFiocBody } from './buildTgssFiocData';
import { goToErrorsView } from './errorViewNavigation';

const sendInviteService = (dispatch, data, accessToken, callback) => {
    Api.post(apiURLBuilder.getURL('sendInviteJointholder'), {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: data,
    }).then(
        () => {
            dispatch(formActions.change('userProfile.jointHolderInvited', true));
            callback(true, 0);
        },
        error => {
            if (error.body.errors['0901']) {
                callback(false, 1);
            } else if (error.body.errors['0902']) {
                callback(false, 2);
            }
        }
    );
};

const addService = (dispatch, data, accessToken, callback, errorCallback) => {
    data.inviteDto.docType = getAliasesDocumentType(data.inviteDto.docType);
    const getAddJointHolderURL = apiURLBuilder.getURL('addJointHolder');
    Api.post(getAddJointHolderURL, {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: data,
    }).then(
        () => {
            dispatch(formActions.change('userProfile.jointHolderSaved', true));
            callback(true);
        },
        error => {
            if (error.body.error === '6006') {
                errorCallback();

                return;
            }
            errorTag(error.body, PATH_ADD_JOINHOLDER, ERROR_AL_AGREGAR_INTERVINIENTE, error.statusCode);
            dispatch(goToErrorsView({ errorCode: error?.status, errorMessage: getAddJointHolderURL }));
        }
    );
};

const removeService = (dispatch, data, accessToken, callback) => {
    const getRemoveJointHolderURL = apiURLBuilder.getURL('removeJointHolder');
    Api.post(getRemoveJointHolderURL, {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: data,
    }).then(
        () => {
            callback(true);
        },
        error => {
            errorTag(error.body, PATH_ADD_JOINHOLDER, ERROR_AL_ELIMINAR_INTERVINIENTE, error.statusCode);
            dispatch(goToErrorsView({ errorCode: error?.status, errorMessage: getRemoveJointHolderURL }));
        }
    );
};

const saveService = (dispatch, data, accessToken, callback) => {
    const getSaveJointHolderURL = apiURLBuilder.getURL('saveJointHolder');
    Api.post(getSaveJointHolderURL, {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: data,
    }).then(
        () => {
            callback(true);
        },
        error => {
            errorTag(error.body, PATH_ADD_JOINHOLDER, ERROR_AL_EDITAR_INTERVINIENTE, error.statusCode);
            dispatch(goToErrorsView({ errorCode: error?.status, errorMessage: getSaveJointHolderURL }));
        }
    );
};

const sendInvite = (data, accessToken, callback) => {
    return dispatch => {
        sendInviteService(dispatch, data, accessToken, callback);
    };
};

const verifytokenService = (dispatch, token, callback) => {
    const url = apiURLBuilder.getURL('getVerifytokenJointHolder', { token });
    Api.get(url).then(
        response => {
            dispatch(formActions.change('userProfile.product', response.body.productCode));
            dispatch(formActions.change('userProfile.onboardingType', response.body.onboardingType));

            const productsInfo = {
                products: response.body.accountOwnerDto.products,
                productsDescription: response.body.accountOwnerDto.productsDescription,
                promotionalCode: response.body.accountOwnerDto.promotionalCode,
                status: response.body.status,
            };

            const data = {
                invite: response.body.inviteDto,
                accountOwner: response.body.accountOwnerDto,
                productsInfo,
                productCode: response.body.productCode,
                onboardingType: response.body.onboardingType,
            };

            callback(response.body.status, data);
        },
        error => {
            callback(error.body.status, null);
        }
    );
};

const getNewOtpService = (dispatch, accessToken, callback) => {
    Api.get(apiURLBuilder.getURL('getOtp'), {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    }).then(
        response => {
            if (response.body.status === 'OK') {
                callback(true);
            } else {
                callback(false);
            }
        },
        () => {
            callback(false);
        }
    );
};

const verifyOtpService = (dispatch, data, accessToken, callback) => {
    Api.post(apiURLBuilder.getURL('otpVerifyJointholder'), {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: data,
    }).then(
        () => {
            dispatch(formActions.change('userProfile.jointHolderInvited', true));
            callback(true);
        },
        error => {
            callback(false, error);
        }
    );
};

const sendPendingInvitationService = (dispatch, accessToken, callback) => {
    dispatch(preLoaderActions.showPreLoader());
    Api.post(apiURLBuilder.getURL('sendPendingMailsJointholder'), {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    }).then(
        response => {
            dispatch(preLoaderActions.hidePreLoader());
            if (response.body.status === 'OK') {
                callback(true);
            } else {
                callback(false);
            }
        },
        () => {
            dispatch(preLoaderActions.hidePreLoader());
            callback(false);
        }
    );
};

const add = (data, accessToken, callback, errorCallback) => {
    return dispatch => {
        addService(dispatch, data, accessToken, callback, errorCallback);
    };
};

const remove = (data, accessToken, callback) => {
    return dispatch => {
        removeService(dispatch, data, accessToken, callback);
    };
};

const save = (data, accessToken, callback) => {
    return dispatch => {
        saveService(dispatch, data, accessToken, callback);
    };
};

const verifytoken = (token, callback) => {
    return dispatch => {
        verifytokenService(dispatch, token, callback);
    };
};

const getNewOtp = (accessToken, callback) => {
    return dispatch => {
        getNewOtpService(dispatch, accessToken, callback);
    };
};

const verifyOtp = (data, accessToken, callback) => {
    return dispatch => {
        verifyOtpService(dispatch, data, accessToken, callback);
    };
};

const sendPendingInvitation = (accessToken, callback) => {
    return dispatch => {
        sendPendingInvitationService(dispatch, accessToken, callback);
    };
};

const sendJointHolderTgssInfo = (accessToken, callback) => dispatch => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: dispatch(buildTgssFiocBody({ withDocumentation: true })),
    };

    Api.post(apiURLBuilder.getURL('saveJointHolderTgss'), requestData)
        .then(() => {
            callback();
        })
        .catch(() => {});
};

export default {
    add,
    remove,
    save,
    sendInvite,
    verifytoken,
    getNewOtp,
    verifyOtp,
    sendPendingInvitation,
    sendJointHolderTgssInfo,
};
